import { Controller } from "@hotwired/stimulus"

// Opens a Bootstrap modal with embedded video content when overlay is clicked.
export default class extends Controller {
  open() {
    const embed = this.element.querySelector('.embed-responsive')
    if (!embed) return

    const $modal = jQuery('.modal')
    $modal.find('.modal-body').html(embed.outerHTML)
    $modal.modal('show')
    $modal.on('hidden.bs.modal', function() {
      $modal.find('.modal-body').html('')
    })
  }
}
